module.exports = __webpack_public_path__ + "static/img/t1-3-1.9d22e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-3-1.png
// module id = miZI
// module chunks = 1